import React, { useState } from 'react';
import Singleton from '../../../core/singleton';
import { AirportsInput } from '../../../ui/AirportsSelectList/AirportsInput';
import restrictToLetters from '../../../utils/restrictToLetters';
import AxiosServices from '../../../services/AxiosServices';
import events from '../../../core/events';

export const ResetTrip = props => {
    const { trip, close } = props;
    const { getTradByKey, eventEmitter } = Singleton.getInstance();
    const [iataFrom, setIataFrom] = useState(null);
    const [iataTo, setIataTo] = useState(null);
    const [airports, setAirports] = useState([]);

    const SubmitButton = props => <div className="modal-footer">
        <button disabled={props.disabled} type="submit" className="btn btn-primary btn-block">
            {getTradByKey('continue')} <i className="fas fa-angle-right"></i>
        </button>
    </div>
    /** on form submit, globally tell the app that the flight had a new route */
    const onFormSubmit = (form) => {
        form.preventDefault();
        eventEmitter.emit(events.ON_USER_ROUTE_SELECT, {
            iataFrom: iataFrom, iataTo: iataTo
        });
        close();
    }
    /** feed the dropdown with data*/
    const getAeroportByIata = searchValue => {
        if (typeof (searchValue[0]) !== "undefined") {
            return AxiosServices.airportsByIataCached(searchValue).then(results => {
                setAirports(results.data);
            })
        }
    }
    return <>
        <div className="modal-header">
            <h5 className="modal-title">{getTradByKey('flight')} <i className="fas fa-plane"></i> {trip.iataFrom} <i className="fas fa-angle-right"></i> {trip.iataTo}</h5>
            <button onClick={() => close()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form className='reset-trip-submit-form' onSubmit={onFormSubmit}>
            <div className="modal-body">
                <h5>{getTradByKey('select_a_new_route')}</h5>
                <div className="form-group">
                    <div className="row">
                        <div className="col-auto">
                            <div className="form-check form-check-inline">
                                <input name="inlineRadioOptions" className="form-check-input" type="radio" id="keep_current_inventory" value="option1" />
                                <label className="form-check-label" htmlFor="keep_current_inventory">{getTradByKey('keep_current_inventory')}</label>
                            </div>
                        </div>
                        <div className="col text-right">
                            <div className="form-check form-check-inline">
                                <input name="inlineRadioOptions" className="form-check-input" type="radio" id="reset_inventory" value="option1" />
                                <label className="form-check-label" htmlFor="reset_inventory">{getTradByKey('reset_inventory')}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col">
                        <AirportsInput
                            onKeyUp={event => { restrictToLetters(event); getAeroportByIata(event.target.value.toUpperCase()) }}
                            id="IATA-From"
                            name="IATA-From"
                            placeholder={getTradByKey('iata_from')}
                            exclude={iataTo}
                            onSelect={setIataFrom}
                            inputId={'IATA-From'}
                            airports={airports}
                        />
                    </div>
                    <div className="col">
                        <AirportsInput
                            onKeyUp={event => { restrictToLetters(event); getAeroportByIata(event.target.value.toUpperCase()) }}
                            id="IATA-To"
                            name="IATA-To"
                            placeholder={getTradByKey('iata_to')}
                            exclude={iataFrom}
                            onSelect={setIataTo}
                            inputId={'IATA-To'}
                            airports={airports}
                        />
                    </div>
                </div>
            </div>
            <SubmitButton disabled={!((iataFrom && iataTo))} />
        </form>
    </>
}